export function downloadBlob(blob, filename) {
    var legacyNavigator = navigator;
    if (blob != null && legacyNavigator.msSaveOrOpenBlob) {
        return legacyNavigator.msSaveOrOpenBlob(blob, filename);
    }
    var a = document.createElement('a');
    a.style.display = 'none';
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
        window.URL.revokeObjectURL(url);
        a.remove();
    }, 10000);
}
